module.exports = __webpack_public_path__ + "static/media/5-Reasons-to-learn-JS.2573814f.png";